export default {
  sizes: {
    container: {
      xl: '1202px',
      '2xl': '1812px',
    },
  },
};
